import cn from 'classnames';
import { Badge } from 'react-bootstrap';

import { IconButton } from 'components/IconButton/IconButton';

import styles from './RowDetails.module.scss';

export const RowDetails = ({ children, className }) => (
  <div className={cn(styles.root, { [className]: className })}>{children}</div>
);

const Column = ({ title, data }) => (
  <div className={styles.column}>
    <span className={cn(styles.title, 'secondary-text')}>{title}</span>
    <span className={cn(styles.data, 'primary-text')}>{data}</span>
  </div>
);

const Action = ({ icon, prefix = 'fa', tooltip, disabled = false, onClick = () => {} }) => (
  <IconButton
    prefix={prefix}
    className={styles.action}
    icon={icon}
    tip={tooltip}
    disabled={disabled}
    onClick={onClick}
  />
);

const Status = ({ status }) => (
  <Badge className={cn(`u-status-${status}`, 'u-margin-left', styles.status)}>{status || ''}</Badge>
);

RowDetails.Column = Column;
RowDetails.Action = Action;
RowDetails.Status = Status;
